/*! Copyright (c) Safe As Milk. All rights reserved. */
import Cart from "cart-store";

class CartLink extends HTMLElement {
    constructor() {
        super();
        this.itemsCount = this.querySelector("items-count");
    }
    connectedCallback() {
        this.unsubscribe = Cart.subscribe((state => {
            const nextCount = state.cart.item_count.toString();
            if (this.itemsCount) {
                this.itemsCount.innerHTML = nextCount;
            }
            document.querySelectorAll("items-count").forEach((element => {
                element.innerHTML = nextCount;
            }));
        }));
    }
    disconnectedCallback() {
        this.unsubscribe();
    }
}

customElements.define("cart-link", CartLink);
//# sourceMappingURL=cart-link.js.map
